<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-13 16:03:35
 * @FilePath: \mrc-ess-fronted\src\Page\Other\Roster\components\RosterPlan.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-15 11:41:31
-->
<template>
  <v-container fluid class="rounded-lg pa-0 white" ref="plan">
    <!-- loading -->
    <v-sheet
      class="
        loading_container
        text-center
        d-flex
        align-center
        justify-center
        fill-height
        rounded-lg
      "
      v-if="loading && false"
      :width="$refs['plan'].offsetWidth"
    >
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        color="primary"
      ></v-progress-circular>
    </v-sheet>
    <!-- 分页 -->
    <!-- <v-row dense no-gutters style="height: 40px">
      <v-col md="2" class="pa-0"></v-col>
      <v-col
        md="10"
        class="text-center pa-0 align-center d-flex justify-center"
      >
        <v-btn
          icon
          small
          color="primary "
          class="transparent"
          @click="onTrigerPage('red')"
        >
          <span class="material-icons-round">chevron_left</span>
        </v-btn>
        <v-btn
          rounded
          text
          class="transparent mx-4 text-capitalize primary--text"
          small
          @click="onTrigerPage(null)"
          >{{ $t("label_essweb_system_todayLabel") }}</v-btn
        >
        <v-btn
          icon
          small
          color="primary "
          class="transparent"
          @click="onTrigerPage('add')"
        >
          <span class="material-icons-round">chevron_right</span>
        </v-btn>
      </v-col>
    </v-row> -->
    <!-- 日期 -->
    <v-row
      dense
      no-gutters
      style="border-bottom: 1px solid var(--main-border-color)"
      class="pb-0 d-flex flex-row flex-nowrap"
    >
      <v-col
        v-for="n in cycleType + 1"
        :key="n + 'col'"
        :cols="n === 1 ? 1 : undefined"
        class="text-center fill-height pa-0 align-center"
      >
        <!--  :style="{
          borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
        }" -->
        <v-card
          class="pa-0 fill-height max-width align-end align-items-end"
          :elevation="0"
          tile
        >
          <template v-if="n === 1"> </template>
          <template v-else>
            <div class="fill-height max-width d-flex justify-end flex-column">
              <DaySelect
                :time="curPageDate[n - 2]"
                :selectStartDate="selectStartDate"
                :selectEndDate="selectEndDate"
              />
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-container class="max-width pa-0 ma-0 rounded-lg" fluid>
      <!-- buglist 1526  -->
      <v-sheet v-if="RosterList.length <= 0" height="300"></v-sheet>
      <v-row
        dense
        no-gutters
        class="max-width flex-nowrap d-flex flex-row"
        v-for="(tr, index) in RosterList"
        :key="index + 'roster'"
        style="height: 100px"
      >
        <v-col
          v-for="n in cycleType + 1"
          :key="n + 'col'"
          :cols="n === 1 ? 1 : undefined"
          :style="{
            borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
          }"
          class="text-center max-width fill-height align-center flex-shrink-0"
        >
          <shiftCard2
            :col="n"
            :roster_uuid="Roster_uuid"
            :curType="cycleType"
            :curData="tr"
            :allCheck="allCheck"
            :selectStaffs="selectStaffs"
            :isEdited="isEdited"
            @check="onCheckStaff"
            :shiftList="shiftList"
            :selectStartDate="selectStartDate"
            :selectEndDate="selectEndDate"
            :curDate="curPageDate[n - 2]"
            @onShift="toShift"
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- 分页 -->
    <!-- <v-row
      dense
      no-gutters
      style="height: 40px; border-top: 1px solid var(--main-border-color)"
    >
      <v-col md="2" class="pa-0"></v-col>
      <v-col
        md="10"
        class="text-center pa-0 align-center d-flex justify-center"
      >
        <v-btn
          icon
          small
          color="primary "
          class="transparent"
          @click="onTrigerPage('red')"
        >
          <span class="material-icons-round">chevron_left</span>
        </v-btn>
        <v-btn
          rounded
          text
          class="transparent ml-2 mr-2 text-capitalize primary--text"
          small
          @click="onTrigerPage(null)"
          >{{ $t("label_essweb_system_todayLabel") }}</v-btn
        >
        <v-btn
          icon
          small
          color="primary "
          class="transparent"
          @click="onTrigerPage('add')"
        >
          <span class="material-icons-round">chevron_right</span>
        </v-btn>
      </v-col>
    </v-row> -->
  </v-container>
</template>
<script>
import DateSelect from "@/Page/Other/Roster/components/DateSelect";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import shiftCard2 from "@/Page/Other/Roster/components/shiftCard2";
import DaySelect from "@/Page/Other/Roster/components/DaySelect";
export default {
  name: "RosterPlan",
  components: {
    DateSelect,
    DaySelect,
    shiftCard2,
  },
  computed: {
    // ...mapGetters(["companyLang", ]),
    loadingHeight() {
      return $(".main-content").height();
    },
    loadingWidth() {
      return $(".main-content").width();
    },
    totalDay() {
      if (this.startTime && this.endTime) {
        return dayjs(this.endTime).diff(dayjs(this.startTime), "day") + 1;
      } else {
        return 0;
      }
    },
    allDayByPage() {
      var arr = [];
      const that = this;
      const chunk = this.cycleType;
      for (var i = 0, j = that.allDay.length; i < j; i += chunk) {
        arr.push(that.allDay.slice(i, i + chunk));
      }
      return arr;
    },
    allDay() {
      var arr = [];
      const that = this;
      if (this.startTime && this.endTime) {
        var daylen = dayjs(this.endTime).diff(dayjs(this.startTime), "day"); //总天数
        for (var i = 0; i <= daylen; i++) {
          arr.push(dayjs(that.startTime).add(i, "day").format("YYYY-MM-DD"));
        }
      }
      return arr;
    },
    curPageDate() {
      if (this.page > 0) {
        return this.allDayByPage[this.page - 1];
      } else {
        return this.allDayByPage[0];
      }
    },
    allStaffs() {
      let arr = [];
      this.RosterList.map((item) => {
        arr.push(Number(item.staff_id)); //2020-10-20 staff_id-->user_id
      });
      return arr;
    },
  },
  props: {
    token: { default: null, type: [Number, String] },
    cycleType: { default: 14, type: Number },
    Roster_uuid: { default: "", type: String },
    startTime: { default: "", type: String },
    isEdited: { default: false, type: Boolean },
    showExportOut: { default: false, type: Boolean },
    showExportIn: { default: false, type: Boolean },
    endTime: { default: "", type: String },
    selectStartDate: { default: "", type: String },
    selectEndDate: { default: "", type: String },
    change: { default: 0, type: Number },
    showRecalcul: { default: false, type: Boolean },
    showRosterForm: { default: false, type: Boolean },
    toDo: {
      default: "",
      type: String,
    },
  },
  watch: {
    showExportIn(val) {
      this.showExIn = val;
    },
    showExIn(val) {
      if (!val) {
        this.$emit("closeExportIn");
      }
    },
    startTime(val) {
      // console.log(val);
      if (val) this.getRosterList();
    },
    endTime(val) {
      // console.log(val);
    },
    loading(val) {
      this.$emit("loadingData", val);
    },
    isEdited(val) {
      if (!val) {
        this.selectStaffs = [];
      }
    },
    selectStartDate(val) {
      // console.log(val);
    },
    selectStaffs(val) {
      this.$emit("check", val);
    },
  },
  mounted() {
    // this.getRosterList();
  },
  methods: {
    closeReculDialog: function () {
      this.$emit("closeCalcul");
    },
    controlNav: function (f) {
      if (!this.nowShow) {
        this.nowShow = true;
      } else {
        this.nowShow = false;
        this.showRosterShift = false;
        this.curData = null;
      }
    },
    closeRosterFormDialog: function () {
      this.$emit("closeRosterForm");
    },
    onTrigerPage: function (logic) {
      this.$emit("onTrigerPage", logic);
    },
    toShift: function (curdata, date) {
      this.curData = curdata;
      this.curData["roster_date"] = date;
      this.showRosterShift = true;
    },
    onCheckStaff: function (staffid, checked) {
      const that = this;
      if (checked) {
        that.selectStaffs.push(staffid);
      } else {
        that.selectStaffs = that.selectStaffs.filter((ele) => ele != staffid);
      }
    },
    toRosterForm: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/generate-roster-records/",
        data: {
          token: this.token,
          roster_form_uuid: obj.roster_form_uuid,
          roster_form_record_title: obj.roster_form_record_title,
          roster_form_record_description: obj.roster_form_record_description,
          staff_uuids: obj.staffIds.join(","),
          manager_uuids: obj.managerIds.join(","),
          // 2021-01-06 liang
          start_time: this.$getTimeValue(this.selectStartDate),
          end_time: this.$getTimeValue(this.selectEndDate),
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          color: "black",
          text: that.$t(
            "message_essweb_rosterRecord_form_dialog_rosterGeneratedSuccessLabel"
          ),
          type: "success",
        });
        that.closeRosterFormDialog();
        that.$emit("back");
        that.getRosterList();
      });
    },
    toReCalGen: function (staffs, start, end) {
      const that = this;
      let url = "";
      if (this.toDo == "regenerate") {
        url = "/roster/generate-roster/";
      } else {
        url = "/roster/recalculate/";
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: url,
        data: {
          token: this.token,
          staff_uuids: staffs.join(","),
          start_time: this.$getTimeValue(start),
          end_time: this.$getTimeValue(end),
        },
      }).then((res) => {
        that.$showMessage({
          color: "black",
          text:
            that.toDo == "regenerate"
              ? that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterGenerateInitSuccessLabel"
                )
              : that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterRecalculateSuccessLabel"
                ),
          type: "success",
        });
        that.closeReculDialog();
        that.getRosterList();
      });
    },

    getRosterList() {
      const that = this;
      this.loading = true;
      // this.RosterList = [];
      // if (this.Roster_uuid != "") {
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-roster-large-table/",
        data: {
          token: this.token,
          type: 2,
          cpage: 1,
          pagesize: 100,
          start_time: this.$getTimeValue(this.startTime),
          end_time: this.$getTimeValue(this.endTime),
        },
      })
        .then((res) => {
          that.RosterList = res.data;
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
        })
        .catch((err) => {
          that.RosterList = [];
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
          that.$showMessage({
            title: that.$t("message_essweb_form_textField_errNoticeTitle"),
            type: "error",
            text: err,
          });
        });
    },
  },
  data() {
    return {
      page: 1,
      showRosterShift: false,
      selectStaffs: [],
      curData: null,
      nowShow: false,
      showExIn: false,
      loading: false,
      allCheck: false,
      RosterList: [],
      shiftList: [],
    };
  },
};
</script>
<style scoped>
.loading_container {
  position: absolute;
  z-index: 9;
  margin-left: -12px;
  margin-top: -12px;
  background: rgba(0, 0, 0, 0.3);
}
</style>
